import { motion, useReducedMotion } from "framer-motion";
import { FEATURES } from "@/components/companion/features";

// Compact, scrollable row of the six premium features inside Ellie's chat.
export const FeatureBubbles = ({ highlight, onOpen }) => {
  const reduce = useReducedMotion();
  return (
    <nav aria-label="FioNova features" data-testid="feature-bubbles"
      className="no-scrollbar -mx-1 flex gap-2 overflow-x-auto px-1 pb-2 sm:flex-wrap sm:overflow-visible">
      {FEATURES.map(({ key, label, Icon }) => {
        const lit = highlight === key;
        return (
          <motion.button key={key} type="button" data-testid={`feature-bubble-${key}`} data-lit={lit ? "true" : "false"}
            onClick={() => onOpen(key)}
            animate={lit && !reduce ? { boxShadow: ["0 0 0 0 rgba(13,148,136,0)", "0 0 0 6px rgba(13,148,136,0.18)", "0 0 0 0 rgba(13,148,136,0)"] } : {}}
            transition={{ duration: 2, ease: "easeInOut" }}
            className={`flex shrink-0 items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary ${lit ? "bg-primary/12 text-primary ring-1 ring-primary/50" : "bg-card/80 text-muted-foreground ring-1 ring-border hover:text-foreground hover:ring-primary/40"}`}>
            <Icon className="h-3.5 w-3.5" strokeWidth={1.75} aria-hidden />
            {label}
          </motion.button>
        );
      })}
    </nav>
  );
};
